// @flow strict

import { Modal, Row } from "antd";
import * as React from "react";
import { confirmable } from "react-confirm";
import "./MyAlertDialog.css";
function MyAlertDialog(props) {
  const { show, proceed, appInfo, title, content } = props;
  let curDomain = window.location.hostname;
  if (curDomain.trim() == "localhost" || curDomain.trim() == "192.168.100.81") {
    curDomain = "devtuxedocamp.beclutch.club";
    // curDomain = "devyaccamp.beclutch.club";
  }

  return (
    <Modal
      visible={show}
      destroyOnClose={true}
      onCancel={() => {
        proceed(null);
      }}
      className="alert-rec-modal"
      closable={true}
      maskClosable={false}
      title={title}
      footer={null}
    >
      {content ? (
        typeof content === "string" ? (
          <div style={{ whiteSpace: "pre-line" }}>{content}</div>
        ) : (
          content
        )
      ) : (
        <>
          <p className="rec-alert-title">Registration is Currently CLOSED</p>
          <p className="rec-alert-content">Please contact <a href={`mailto:${appInfo?.registration_info.admin_email}`}>{appInfo?.registration_info.admin_email}</a> with any questions</p>
        </>
      )}
    </Modal>
  );
}

export default confirmable(MyAlertDialog);
